<div kalDialogHeader>

    <div class="kal-dialog__title">Commentaires</div>
    <kal-icon (click)="close()">close</kal-icon>

</div>

<div kalDialogContent>

    <kal-tab-group>

        <div *ngFor="let comment of data.commentsList">

            <kal-tab *ngIf="comment.publicComment || comment.privateComment">

                    <ng-template  kalTabLabel>
                        <div class="kal-tab-header__label">{{ comment.label }}</div>
                    </ng-template>

                    <ng-template kalTabContent>

                        <ng-container *ngIf="comment.publicComment">
                            <div>
                                <label>Commentaire public</label>

                                <span>{{comment.publicComment}}</span>
                            </div>

                        </ng-container>

                        <ng-container *ngIf="comment.privateComment">

                            <div>
                                <label>Commentaire privé</label>

                                <div>{{comment.privateComment}}</div>

                            </div>

                        </ng-container>

                    </ng-template>

            </kal-tab>

        </div>

    </kal-tab-group>

</div>

